import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'underscore';
import htmlReactParser from 'html-react-parser';

import {
	toggleSearchActive,
} from '../../../store/actions';

import {
	searchIsActive,
} from '../../../store/selectors';

import { getParentElementByClass } from '../../../framework/helpers';

import './search-bar.scss';

class SearchBar extends Component {
	state = {
		// eslint-disable-next-line react/destructuring-assignment
		search: this.props.data.searchString || '',
		searchStripped: '',
		suggestions: [],
		open: false,
		resetClass: this.props.data.searchString ? 'search-bar__reset search-bar__reset--visible': 'search-bar__reset'
	};

	static getDerivedStateFromProps(props) {
		const { inHeader, searchActive } = props;

		// Clearing search and suggestions when the user closes the header search dropdown
		if (inHeader && !searchActive) {
			return {
				search: '',
				suggestions: [],
				open: false,
				resetClass: 'search-bar__reset'
			};
		}

		return null;
	}

	constructor(props) {
		super(props);

		this.containerRef = createRef();
		this.inputRef = createRef();

		this.fetchSuggestions = _.debounce(this.fetchSuggestions, 200);

		this.setupListeners();
	}

	setupListeners() {
		const { inHeader } = this.props;

		if (!inHeader) {
			document.addEventListener('click', this.onDocumentClick);
			document.addEventListener('keydown', this.onDocumentKeypress);
		}
	}

	onDocumentClick = (event) => {
		const { target } = event;
		const { current: container } = this.containerRef;
		const searchBar = getParentElementByClass(target, 'search-bar');

		if (!searchBar || (searchBar && searchBar !== container.parentNode)) {
			this.setState({
				open: false,
			});
		}
	}

	onDocumentKeypress = (event) => {
		const { keyCode } = event;
		const { current: input } = this.inputRef;

		if (keyCode === 27) {
			if (input) input.blur();

			this.setState({
				open: false,
			});
		}
	}

	onFormSubmit = (event) => {
		event.preventDefault();
	}

	onInputChange = (event) => {
		const { target: input } = event;

		const newState = {
			search: input.value,
			searchStripped: input.value?.replace(/[^\w\s]/g, ''),
			resetClass: input.value ? 'search-bar__reset search-bar__reset--visible' : 'search-bar__reset',
		};

		if (input.value) {
			this.fetchSuggestions(newState.searchStripped);
		} else {
			newState.suggestions = [];
		}

		this.setState(newState);
	}

	onInputFocus = () => {
		const { suggestions } = this.state;

		if (suggestions && suggestions.length) {
			this.setState({
				open: true,
			});
		}
	}

	onCloseClick = () => {
		this.props.dispatch(toggleSearchActive(false));

		this.setState({
			open: false,
		})
	}

	onResetClick = () => {
		const newState = {
			search: '',
			suggestions: [],
			resetClass: 'search-bar__reset',
		};

		this.setState(newState)
	}

	fetchSuggestions = (searchStripped) => {
		const { search } = this.state;
		const { data } = this.props;
		const { endpoint, endpointParams, queryParam } = data;

		const postData = {
			...endpointParams,
			[queryParam]: searchStripped,
		};

		fetch(endpoint, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(postData),
		}).then((response) => {
			return response.json();
		}).then(this.setSuggestions);

	}

	setSuggestions = (response) => {
		const { search } = this.state;
		const { query, results } = response;

		// Checking if the query is equal to the search string to ensure we aren't
		// rendering results from an old (delayed or slow) search request.
		if (search.toLowerCase() === query.toLowerCase()) {
			this.setState({
				suggestions: results,
				open: true,
			});
		} else if (search === '') {
			this.setState({
				suggestions: [],
				open: false,
			});
		}
	}

	renderSuggestion = (suggestion, index) => {
		const { search } = this.state;
		const { data } = this.props;
		const { queryParam, searchUrl } = data;

		// Bolding the search query in the suggestion text
		const searchRegex = new RegExp(`(${search})`, 'gi');
		const text = suggestion.text.split(searchRegex);
		for (let i = 1; i < text.length; i += 2) {
			text[i] = `<b>${text[i]}</b>`;
		}

		return (
			<a
				key={suggestion.id || index}
				href={`${searchUrl}?${queryParam}=${encodeURIComponent(suggestion.text)}`}
				className="search-bar__suggestion"
			>
				{ htmlReactParser(text.join('')) }
			</a>
		);
	}

	render() {
		const { data } = this.props;
		const { search, suggestions, open } = this.state;

		return (
			<section ref={this.containerRef} className={`search-bar__inner${suggestions && suggestions.length && open ? ' has-suggestions' : ''}`}>
				<button className="search-bar__close-cta" onClick={this.onCloseClick}></button>
				<div className="container">
					<div className="row">
						<form
							className="search-bar__form"
							action={data.searchUrl || null}
							onSubmit={data.searchEndpoint ? this.onFormSubmit : null}
							autoComplete="off"
						>
							<button type="submit" className="search-bar__icon" />

							<div className="search-bar__input-wrap">
								<input
									ref={this.inputRef}
									type="text"
									className="search-bar__input"
									name={data.queryParam}
									placeholder={data.placeholder}
									value={this.searchStripped}
									onChange={this.onInputChange}
									onFocus={this.onInputFocus}
								/>
							</div>

							<button type="reset" className={this.state.resetClass} onClick={this.onResetClick}></button>

							<button type="submit" className="search-bar__submit" />
						</form>
					</div>
				</div>

				<div className="search-bar__suggestions-wrap">
					<div className="container">
						<div className="row">
							<div className="search-bar__suggestions">
								{suggestions.map(this.renderSuggestion)}
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}
}

SearchBar.propTypes = {
	inHeader: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	data: PropTypes.shape({
		endpoint: PropTypes.string,
		endpointParams: PropTypes.shape({}),
		queryParam: PropTypes.string,
		searchString: PropTypes.string,
		searchUrl: PropTypes.string,
		placeholder: PropTypes.string,
	}),
};

SearchBar.defaultProps = {
	inHeader: false,
	data: {
		endpoint: '',
		endpointParams: {},
		queryParam: 'q',
		searchString: '',
		searchUrl: '/search',
		placeholder: 'Search anything',
	},
};

const mapStateToProps = (state) => {
	return {
		searchActive: state.menu.searchActive,
	};
};

export default connect(mapStateToProps)(SearchBar);
